// extracted by mini-css-extract-plugin
export default {"headerSection":"BasicLayout_headerSection__JZ7bm"};